import type { IconSvgObject } from './types';

const Download04Icon: IconSvgObject = [
  ["path", { d: "M7.00004 11.5L12 17.5L17 11.5H14L14 3H10L10 11.5H7.00004Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.00005 21H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Download04Icon;
